import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sort"
})
export class ArraySortPipe  implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a, b) => {
      if(a[field] > b[field]) return -1;
      if(a[field] < b[field]) return 1;
      return 0;
    });
    return array;
  }
}
